import React from 'react'
import * as Material from '@mui/material';

function ExperiencePage() {
  return (
    <Material.Box component='main' id="mainPage">
      Experience Page
    </Material.Box>
  )
}

export default ExperiencePage